import { StringParam, withDefault } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'fullNumber',
    label: 'No.',
    sortable: true,
  },
  {
    name: 'search',
    label: 'Account description',
  },
  {
    name: 'accountType',
    label: 'Type',
    sortable: true,
  },
  {
    name: 'closed',
    label: 'Status',
  },
  // {
  //   name: 'overdraftEnabled',
  //   label: 'Overdraft',
  // },
  {
    name: 'debitBlock',
    label: 'Block Debit',
    sortable: true,
  },
  {
    name: 'creditBlock',
    label: 'Block Credit',
    sortable: true,
  },
  {
    name: 'createdAt',
    label: 'Opened',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'closedAt',
    label: 'Closed',
    filterModalPlacement: 'right',
    sortable: true,
  },
];

export const defaultSorter = {
  sortProp: columns[1].name,
  sortDir: SortDir.ASC,
};

export const schema = {
  createdAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['createdDateFrom', 'createdDateTo'],
  },
  closedAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['closedDateFrom', 'closedDateTo'],
  },
  createdDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  createdDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  closedDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  closedDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  fullNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  search: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  clientName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  accountType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  closed: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  debitBlock: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  creditBlock: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  categoryId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  groupId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  includes: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  closingBalancesAt: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  primaryId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  blockDebit: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  blockCredit: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'fullNumber',
    type: FilterType.TEXT,
    placeholder: 'Search by number...',
  },
  {
    name: 'search',
    type: FilterType.TEXT,
    placeholder: 'Search by name...',
  },
  {
    name: 'accountType',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'accountType',
        title: 'Debit',
        value: 'DEBIT',
      },
      {
        name: 'accountType',
        title: 'Credit',
        value: 'CREDIT',
      },
    ],
  },
  {
    name: 'closed',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'closed',
        title: 'Open',
        value: 'false',
      },
      {
        name: 'closed',
        title: 'Closed',
        value: 'true',
      },
    ],
  },
  {
    name: 'debitBlock',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'debitBlock',
        title: 'Yes',
        value: 'true',
      },
      {
        name: 'debitBlock',
        title: 'No',
        value: 'false',
      },
    ],
  },
  {
    name: 'creditBlock',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'creditBlock',
        title: 'Yes',
        value: 'true',
      },
      {
        name: 'creditBlock',
        title: 'No',
        value: 'false',
      },
    ],
  },
  {
    name: 'createdAt',
    type: FilterType.DATE_RANGE,
  },
  {
    name: 'closedAt',
    type: FilterType.DATE_RANGE,
  },
];

export const columnsLabels = {
  closedAt: 'Closed',
  createdAt: 'Opened',
  createdDateFrom: 'Opened From',
  createdDateTo: 'Opened To',
  closedDateFrom: 'Closed From',
  closedDateTo: 'Closed To',
  fullNumber: 'No.',
  clientName: 'Client Name',
  search: 'Client description',
  closed: 'Status',
  accountType: 'Type',
  debitBlock: 'Block Debit',
  creditBlock: 'Block Credit',
  sort: 'Sort name',
  sortDir: 'Sort direction',
};
